// PayDirt Constants — Shared constants and helper functions

export const sc = s => s >= 85 ? "#00e676" : s >= 70 ? "#ffab00" : s >= 50 ? "#ff6d00" : "#ff1744";
export const CATS = ["US News", "World", "Business", "Sports", "Technology"];

export const DirtIcon = s => s && s < 50 ? '💩 ' : '';

export const CRITERIA_INFO = {
  composite: { color: "#00e676", label: "PAYDIRT SCORE", weight: "100%", what: "Weighted average of all 6 credibility criteria.", standard: "85+ excellent · 70–84 solid · below 70 needs work" },
  evidence: { color: "#2196f3", label: "EVIDENCE TRACING", weight: "25%", what: "Are claims tied to named documents, official data, court filings, or on-record sources?", standard: "90+ nearly every claim sourced · below 60 relies on anonymous tips" },
  sources: { color: "#9c27b0", label: "SOURCE INDEPENDENCE", weight: "20%", what: "Multiple independent sources? Checks for single-source stories and circular reporting.", standard: "85+ = 3+ independent sources · below 60 single-source or circular" },
  confidence: { color: "#ff9800", label: "CLAIM CONFIDENCE", weight: "15%", what: "Does language strength match evidence strength?", standard: "85+ language matches evidence · below 60 overconfident without data" },
  headlines: { color: "#e91e63", label: "HEADLINE ACCURACY", weight: "20%", what: "Does the headline accurately represent the article?", standard: "90+ headline matches article · below 50 headline contradicts story" },
  corrections: { color: "#795548", label: "CORRECTION RECORD", weight: "5%", what: "Does the outlet publish corrections when errors are found?", standard: "90+ same-day corrections · below 50 errors go unaddressed" },
  ai_detection: { color: "#00bcd4", label: "AI DETECTION", weight: "15%", what: "Does the writing appear to be human-authored? Evaluates text patterns, voice consistency, and structural variety.", standard: "90+ clearly human · below 50 likely AI-generated" },
};

export function detectCriteria(question) {
  const q = (question || '').toLowerCase();
  if (q.includes('uncited claim') || q.includes('unnamed source') || q.includes('named document') || q.includes('named source')) return 'evidence';
  if (q.includes('single-source') || q.includes('circular')) return 'sources';
  if (q.includes('definitive language') || q.includes('will definitely') || q.includes('guaranteed') || q.includes('overconfident')) return 'confidence';
  if (q.includes('headline') || q.includes('exaggerated') || q.includes('clickbait')) return 'headlines';
  if (q.includes('correction') || q.includes("editor's note")) return 'corrections';
  if (q.includes('average') || q.includes('paydirt score')) return 'composite';
  return 'composite';
}

export const CADS = [
  { id: "daily", label: "Daily", icon: "⚡", color: "#ff1744" },
  { id: "weekly", label: "Weekly", icon: "📅", color: "#2196f3" },
  { id: "monthly", label: "Monthly", icon: "📊", color: "#ffab00" },
];

export const QTYPES = [
  { id: "clean_sheet", label: "Credibility Props", icon: "🛡️", color: "#2196f3", desc: "● Can they keep it honest all day long?" },
  { id: "head_to_head", label: "Head to Head", icon: "⚔️", color: "#ff9800", desc: "● Outlet vs. Outlet matchup" },
  { id: "threshold", label: "Over/Under", icon: "↕️", color: "#9c27b0", desc: "● Over or under the threshold?" },
  { id: "main_line", label: "Main Line", icon: "📈", color: "#00e676", desc: "● Beat the previous period's PayDirt score" },
];

export function getCadenceProgress(cadId) {
  const now = new Date();
  if (cadId === "daily") return { pct: Math.round((now.getHours() / 24) * 100), label: `${24 - now.getHours()}h left` };
  const dw = (now.getDay() + 6) % 7;
  if (cadId === "weekly") return { pct: Math.round(((dw * 24 + now.getHours()) / (7 * 24)) * 100), label: `${7 - dw}d left` };
  const dim = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  return { pct: Math.round((now.getDate() / dim) * 100), label: `${dim - now.getDate()}d left` };
}
